import applePay from "../../../assets/images/apple_pay.svg";
import googlePay from "../../../assets/images/google_pay.svg";
import samsungPay from "../../../assets/images/samsung_pay.svg";
import fitbit from "../../../assets/images/fitbit_pay.svg";
import garminPay from "../../../assets/images/garmin_pay.svg";
import cardPlaceholder from "../../../assets/images/card-placeholder.svg";
export const features = [
    {
        label: "Apple Pay",
        value: "apple-pay",
        icon: applePay,
    },
    {
        label: "Google Pay",
        value: "google-pay",
        icon: googlePay,
    },
    {
        label: "Samsung Pay",
        value: "samsung-pay",
        icon: samsungPay,
    },
    {
        label: "Fitbit Pay",
        value: "fitbit-pay",
        icon: fitbit,
    },
    {
        label: "Garmin Pay",
        value: "garmin-pay",
        icon: garminPay,
    },
    {
        label: "Others",
        value: "others",
        icon: cardPlaceholder,
    },
];
export const otpDeliveryMethods = [
    { label: "E-mail", value: "email" },
    { label: "SMS", value: "sms" },
    { label: "SMPP Integration", value: "smpp-integration" },
    { label: "Push API", value: "push-api" },
];
export const yellowPathOtp = [
    { label: "OTP via E-mail", value: "via-email" },
    { label: "OTP via SMS", value: "via-sms" },
    { label: "Speak to Live Agent", value: "live-agent" },
];
export const liveAgent = [
    { label: "i2c Inc.", value: "i2c" },
    { label: "Client/Bank", value: "client-bank" },
    { label: "Other, please specify", value: "other" },
    { label: "N/A", value: "n/a" },
];
export const emailAgent = [
    { label: "i2c Inc.", value: "i2c" },
    { label: "Client/Bank", value: "client-bank" },
    { label: "Other, please specify", value: "other" },
    { label: "N/A", value: "n/a" },
];

export const acsServiceProvider = [
    { label: "i2c Inc.", value: "i2c Inc." },
    { label: "Other", value: "other" },
    { label: "N/A", value: "n/a" },
];
export const otpProvider = [
    { label: "i2c Inc.", value: "i2c Inc." },
    { label: "Client", value: "client" },
    { label: "Other", value: "other" },
    { label: "N/A", value: "n/a" },
];
export const corporateFundingSource = [
    // {
    //     value: "premium",
    //     label: "Premium",
    //     text: "Covers dispute and chargeback investigation and filing. Card programs under this subscription will be covered for some fraud losses.",
    // },
    {
        value: "managed",
        label: "Managed",
        text: "Fraud module is enabled for the card program, and it is managed by i2c team based on the configurations the clients define.",
    },
    {
        value: "standard",
        label: "Standard",
        text: "Fraud module is enabled for your card program, and it is managed by the client.",
    },
    {
        value: "other",
        label: "Other (External 3rd Party Vendor)",
        text: "Not managed by i2c Inc",
    },
    {
        value: "n/a",
        label: "N/A",
        text: "",
    },
];
export   const otherServices = [
    { label: "Bill Payment", value: "bill-payment"},
    { label: "Campaign Manager", value: "campaign-manager" },
    { label: "i-Coupons", value: "i-coupons" },
    { label: "Promotions/Installments", value: "promotions-installments" },
    { label: "Reward Points/Cashbacks", value: "reward-points-cashbacks" },
    { label: "Other", value: "other" },
  ];